import * as React from 'react';
import { Numberbox } from 'ui';
import { ScreenFieldProps, ScreenField } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';

export const RangeFrom = ({ codeItem, updateByKey, resetValidation, readOnlyConfig, translation, validation }: ScreenFieldProps) => {

  const onChange = (value: number) => {
    resetValidation(ScreenField.rangeFrom);
    updateByKey(ScreenField.rangeFrom, value);
  };

  const rangeFromValidation = !!validation && !!validation.rangeFrom ? validation.rangeFrom : undefined;

  return <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId={ScreenField.rangeFrom}
      readOnly={readOnlyConfig && readOnlyConfig[ReadOnlyType.all]}
      label={{ text: translation.range_from }}
      value={codeItem && codeItem.rangeFrom}
      validation={rangeFromValidation}
      onChange={onChange}
      useThousand=" "
      minValue={0}
      textInvalidRangeError={translation.must_be_within_range}
      maxValue={999999999}
      maxDecimals={0}
    />
  </div>;
};
